import React from "react";

import "../../../css/inputRange.css";

/**
 *input whit the range type
 * @param {string} labelName
 * @param {number} min
 * @param {number} max
 * @param {number} step
 * @param {number} value
 * @param {() => {}} onChange
 * @param {string} classe
 * @returns
 */
const InputRange = ({ labelName, min, max, step, value, onChange, classe }) => {
  return (
    <label>
      <span className="inline-block font-nunito text-xs text-secondary">
        {labelName}
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`${classe} mt-0  w-full cursor-pointer`}
      />
    </label>
  );
};

export default InputRange;
